import { collection, doc, getDoc, getDocs, query, setDoc, deleteDoc, where } from 'firebase/firestore';
import { db, auth } from '../firebase';

export async function getFeesForMyChildren(profile) {
  if (!db || !auth?.currentUser) return [];
  if (profile?.role === 'STUDENT') {
    const ids = [...new Set([profile.admno, profile.studentCsvId].filter(Boolean).map(String))];
    const rows = [];
    for (const id of ids) {
      const snap = await getDoc(doc(db, 'fees', id));
      if (snap.exists()) rows.push({ id: snap.id, ...snap.data() });
    }
    return rows;
  }
  const q = query(collection(db, 'fees'), where('parentUid', '==', auth.currentUser.uid));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function saveFee({ studentId, studentName, parentUid, amountDue, monthsPaid }) {
  if (!db) throw new Error('Firestore not configured.');
  const monthsRaw = monthsPaid == null ? '' : String(monthsPaid);
  const months = monthsRaw
    .split(/[\n,]+/)
    .map((m) => m.trim())
    .filter(Boolean);
  const payload = {
    studentName,
    amountDue: Number(amountDue),
    monthsPaid: months,
    updatedAt: new Date().toISOString(),
  };
  if (parentUid) payload.parentUid = parentUid;
  await setDoc(doc(db, 'fees', studentId), payload, { merge: true });
}

export async function listAllFees() {
  if (!db) return [];
  const snap = await getDocs(collection(db, 'fees'));
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function deleteFee(studentId) {
  if (!db) throw new Error('Firestore not configured.');
  const id = String(studentId || '').trim();
  if (!id) throw new Error('Student ID is required.');
  await deleteDoc(doc(db, 'fees', id));
}
